import React from 'react';
import AppModal from '../../../components/AppModal/AppModal';
import { STATUS_LABELS } from '../constants';

// Corrections spec 5.2 — same-client duplicate handling.
//
// A client must never receive the same story in two buckets simultaneously.
// Behaviour depends on the story's status in the OTHER bucket:
//   Suggestion                       → warn; offer Copy anyway / Transfer / Cancel
//   Accepted…Handled by publisher    → block a second active appearance
//   Rejected / Archived / Deleted    → allowed (caller does not open this modal)
//   Already in the exact target      → block
export default function DuplicateModal({ conflict, onCopyAnyway, onTransfer, onClose }) {
  if (!conflict) return null;

  const { bucketName, status, sameTarget, storyTitle } = conflict;
  const statusLabel = STATUS_LABELS[status] || status;
  const isSuggestion = status === 'suggestion';

  const body = sameTarget ? (
    <p style={{ margin: 0, fontSize: 14, color: '#3C4A5E', lineHeight: 1.5 }}>
      This story is already in <strong>{bucketName}</strong>. It cannot be added twice to the
      same bucket.
    </p>
  ) : (
    <>
      <p style={{ margin: 0, fontSize: 14, color: '#3C4A5E', lineHeight: 1.5 }}>
        This suggestion already appears in another bucket for the same publisher:{' '}
        <strong>{bucketName}</strong>. Its current status there is <strong>{statusLabel}</strong>.
      </p>
      {!isSuggestion && (
        <p style={{ margin: '10px 0 0', fontSize: 13, color: '#3C4A5E', lineHeight: 1.5 }}>
          Because the story is already in production for this publisher, it cannot appear in a
          second bucket at the same time.
        </p>
      )}
      {storyTitle && (
        <p style={{ margin: '12px 0 0', fontSize: 13, color: '#0B1E3F', fontStyle: 'italic' }}>
          “{storyTitle}”
        </p>
      )}
    </>
  );

  // Blocked cases get a single dismiss button; only a Suggestion offers choices.
  const footer = (sameTarget || !isSuggestion) ? (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
      <button className="pbnew-btn" onClick={onClose}>Close</button>
    </div>
  ) : (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginTop: 20 }}>
      <button className="pbnew-btn" onClick={onClose}>Cancel</button>
      <div style={{ display: 'flex', gap: 10 }}>
        <button className="pbnew-btn" onClick={onCopyAnyway}>Copy anyway</button>
        <button className="pbnew-btn primary" onClick={onTransfer}>Transfer</button>
      </div>
    </div>
  );

  return (
    <AppModal
      isOpen
      title={sameTarget ? 'Already in this bucket' : 'Story already used by this publisher'}
      onCancel={onClose}
      maxWidth={480}
      footer={footer}
    >
      <div className="pbnew-scope">{body}</div>
    </AppModal>
  );
}
